var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#BF3B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8307 11.2558L20.4856 10.5901C21.2595 9.80331 22.6065 9.80331 23.3805 10.5901L23.9088 11.1272C24.0995 11.3193 24.2508 11.5479 24.354 11.7998C24.4573 12.0517 24.5104 12.3219 24.5104 12.5948C24.5104 12.8677 24.4573 13.1379 24.354 13.3898C24.2508 13.6417 24.0995 13.8703 23.9088 14.0624L23.254 14.7281L19.8307 11.2482V11.2558ZM19.0419 12.0577L12.2623 18.9494C12.0465 19.1688 11.9126 19.4563 11.8902 19.7664L11.6893 21.983C11.667 22.2629 11.7637 22.5352 11.9572 22.7395C12.1358 22.921 12.3665 23.0194 12.6121 23.0194H12.694L14.8744 22.8151C15.1795 22.7849 15.4623 22.6487 15.6781 22.4293L22.4577 15.5376L19.0344 12.0577H19.0419ZM26 25.4326C26 25.1225 25.747 24.8652 25.4419 24.8652H10.5581C10.253 24.8652 10 25.1225 10 25.4326C10 25.7428 10.253 26 10.5581 26H25.4419C25.747 26 26 25.7428 26 25.4326Z",
    fill: "#BF3B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.beb34595089f50a33cd553fb1269e87d.svg";
export { ForwardRef as ReactComponent };